(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, Toposequence);

	// Constructor
	function Toposequence() {

		// Super constructor
		BaseGame.call(this);

		// Overide audio click sound
		this.clickSound = "audiojungle-20134560-cheeping-frog.wav";

		// Override toolbar screen since we have a screensaver
		this.activateToolbarFrom = 2;

		// Variable to hold data
		this.data = {
			zones: false,
			vegetaux: false,
			animaux: false,
		}

		this.draggable = false;

		// Load data then init
		this.loadData();
	}

	Toposequence.prototype.loadData = function () {

		// Load JSON for ZONES
		var json1 = $.ajax({
			url: "data/toposequence-1-zones.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data.zones = JSON.parse(data.responseText);
			}, this)
		});

		// Load JSON for VEGETAUX
		var json2 = $.ajax({
			url: "data/toposequence-2-vegetaux.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data.vegetaux = JSON.parse(data.responseText);
			}, this)
		});

		// Load JSON for ANIMAUX
		var json3 = $.ajax({
			url: "data/toposequence-3-animaux.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data.animaux = JSON.parse(data.responseText);
			}, this)
		});

		// Wait for all
		Promise.all([
			json1.promise(),
			json2.promise(),
			json3.promise(),
		]).then($.proxy(function () {
			this.initGame();
		}, this));

	};

	Toposequence.prototype.initGame = function () {

		// Create credits page
		var credits = [];
		$.each(this.data, function (i, n) {
			$(n.items).each(function (i2, n2) {
				if (n2.img) {
					credits.push({
						img: n2.img,
						label: n2.img_credit
					});
				}
			});
		});
		BaseGame.prototype.createCredits.call(this, credits);

		// Go to first element
		this.goToScreen(1);
		// this.goToScreen(5);
		// app.i18n.set("en")
	};


	Toposequence.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		BaseGame.prototype.goToScreen.call(this, screenId, callback);

		if (screenId == 5 || screenId == 7 || screenId == 9) {
			// Init drag games
			var $el = $("#screen-" + screenId);
			console.log("Init drag game for screen " + screenId)
			this.disposeDraggable($el)
			this.initDragGame(this.data[$el.data("drag-game-id")], false, $el);
		}

	}


	Toposequence.prototype.initDragGame = function (data, callback, $el) {

		// Save last item layout for gap calculation
		var layout = "text-layout";

		// Empty current items
		$el.find(".draggable-items").empty();
		$el.find(".items-descriptions").empty();

		// Set background
		$el.find(".drag-game").css("background", "transparent url('" + data.background + "') center center no-repeat");

		// Hide next button
		$el.find(".next").addClass("hidden");

		// Create zones
		$(data.zones).each(function (i, n) {
			var li = $("<li></li>");
			li.attr("id", n.name)
			li.css("width", n.width).css("height", n.height);
			if (data.show_zones_label) {
				li.empty().append("<div class='zone-title'><div class='wrapper'><div class='i18n fading-i18n'><span class='fr'>" + n.title.fr + "</span><span class='en'>" + n.title.en + "</span></div></div></div>");
				li.find(".zone-title").css("left", n.title.x).css("top", n.title.y);
			}
			$el.find(".zones").append(li)
		});

		// Create items
		var shuffledItems = shuffle(data.items);
		$(shuffledItems).each(function (i, n) {
			// Draggable
			var li = $("<li><div class='wrapper'></div></li>");
			li.data("item-id", i);
			li.data("zone", n.zone);
			li.data("final-pos-x", n.final_pos.x);
			li.data("final-pos-y", n.final_pos.y);
			li.find(".wrapper").html("<div class='label'><div class='i18n fading-i18n'><span class='fr'>" + n.title_fr + "</span><span class='en'>" + n.title_en + "</span></div></div>");
			if (n.img) {
				li.find(".wrapper").css("background", "transparent url('" + n.img + "') center center no-repeat");
				li.find(".wrapper").css("background-size", "contain");
				li.addClass("image-layout");
				layout = "image-layout";
			} else {
				li.addClass("text-layout");
			}
			if (n.additional_classes) {
				li.addClass(n.additional_classes);
			}
			$el.find(".draggable-items").append(li);

			// Description
			var li_description = $("<li><div class='wrapper'></div></li>");
			li_description.data("item-id", i);
			li_description.addClass(n.description.layout);
			li_description.css("left", n.description.x);
			li_description.css("top", n.description.y);
			li_description.css("width", n.description.width);
			li_description.find(".wrapper").html("<div class='i18n fading-i18n'><span class='fr'>" + n.description.content_fr + "</span><span class='en'>" + n.description.content_en + "</span></div>");
			$el.find(".items-descriptions").append(li_description)
		});

		// Set gap between element to fill screen
		// requestAnimationFrame(function () {
		var itemsGroupWidth = (data.items.length * (layout == "image-layout" ? 156 : 308));
		var margin = (1310 - itemsGroupWidth) / (data.items.length - 1);
		$el.find(".draggable-items li:not(:last-child)").css("margin-right", margin)
		// })

		// Create draggable beahavior
		this.draggable = new Draggable.Draggable($el.find(".draggable-items").get(), {
			draggable: 'li',
			delay: 0,
		});

		// Variable to hold initial position
		var initialPosition;

		// On drag start
		this.draggable.on('drag:start', function (evt) {

			// Close all description
			$el.find(".items-descriptions li").removeClass("shown");

			// Cancel drag when item is locked
			if($(evt.data.source).hasClass("locked")) {
				console.log("preventDefault", evt.cancelable)
				if(evt.cancelable) {
					evt.cancel();
				}
				return false;
			};

			// Define initial position values
			initialPosition = getPosition(evt.data.source);
			initialPosition.offsetX = evt.sensorEvent.clientX - (initialPosition.combinedX);
			initialPosition.offsetY = evt.sensorEvent.clientY - (initialPosition.combinedY);

			// Add transition effect on release (originalSource) and remove on grab (mirror)
			evt.data.originalSource.style.transition = "transform 0.3s linear";
			evt.data.mirror.style.transition = '';
		});

		// On drag
		this.draggable.on('drag:move', function (evt) {

			var coords = {
				left: evt.sensorEvent.data.clientX - initialPosition.offsetX - initialPosition.x,
				top: evt.sensorEvent.data.clientY - initialPosition.offsetY - initialPosition.y,
			}

			evt.data.originalSource.style.transform = "translate3d(" + coords.left + "px, " + coords.top + "px, 0)";
			// evt.originalSource.style.transition = "transform 0.3s linear";
		});

		this.draggable.on('drag:stop', $.proxy(function (evt) {

			var acceptedZone = $(evt.data.originalSource).data("zone")
			var droppedOnZone = this.zoneDroppedOn(data, evt.data.mirror)

			if (acceptedZone == droppedOnZone.name) {

				// Success
				console.log("Correct zone!")

				// Play audio sound
				this.audio.play("audiojungle-8962547-duck-quack-both.wav");

				// Set as completed
				$(evt.originalSource).data("completed", true);

				var tranform_dest = {
					x: -$(evt.source).offset().left + $(evt.data.originalSource).data("final-pos-x"),
					y: -$(evt.source).offset().top + $(evt.data.originalSource).data("final-pos-y"),
				}

				// Show related description
				var item_id = $(evt.originalSource).data("item-id");
				$el.find(".items-descriptions li").eq(item_id).addClass("shown");

				// Move to finale position
				requestAnimationFrame(function () {
					evt.originalSource.style.transition = "transform 0.3s linear";
					requestAnimationFrame(function () {
						$(evt.originalSource).addClass("locked");
						evt.originalSource.style.transform = "translate3d(" + tranform_dest.x + "px, " + tranform_dest.y + "px, 0)";
					});
				});

			} else {

				// Wrong
				console.log("Wrong zone.")

				// Play audio wrong sound
				this.audio.play("audiojungle-20668144-fishing-fish-catching-with-net.wav");

				// Set completed to fals
				$(evt.originalSource).data("completed", false);

				// Return to original position
				requestAnimationFrame(function () {
					evt.source.style.transform = evt.originalSource.style.transform;
					requestAnimationFrame(function () {
						evt.originalSource.style.transform = "translate3d(0,0, 0)";
					});
				});
			}

			// On complete, show modal and start next drag game
			if (this.checkCompleted($el, data)) {

				// Show next button
				$el.find(".next").removeClass("hidden");
				$el.parent().find(".thumbs-up").removeClass("hidden");
			}


		}, this));
	}

	// Check if all items have been correctly dragged
	Toposequence.prototype.checkCompleted = function ($el, data) {

		var total = data.items.length;
		var count = 0;

		$el.find(".draggable-items li").each(function (i, n) {
			if ($(n).data("completed") == true) {
				count++;
			}
		});

		return (count == total);
	}

	// Destroy Draggable object and events
	Toposequence.prototype.disposeDraggable = function ($el) {

		// Destroy draggable object
		if (this.draggable) {
			this.draggable.destroy();
			this.draggable = false;
		}

		// Remove DOM elements
		$el.find("#zones li").remove()
		$el.find("#draggable-items li").remove()
		$el.find("#items-descriptions li").remove()

		// Reset class
		$el.find(".next").addClass("hidden");
		$el.parent().find(".thumbs-up").addClass("hidden");
	}

	// Define on wich zone is dropped an item
	Toposequence.prototype.zoneDroppedOn = function (data, el) {

		// Get dropped item position
		var itemPos = getPosition(el);
		// console.log(itemPos)

		// Loop through zones to find curent dropped on zone
		var zone = false;
		$(data.zones).each(function (i, n) {
			if (zone != false) return;
			var zoneEl = document.getElementById(n.name);
			var zonePosition = getPosition(zoneEl);

			if (!(itemPos.right < zonePosition.left ||
					itemPos.left > zonePosition.right ||
					itemPos.bottom < zonePosition.top ||
					itemPos.top > zonePosition.bottom)) {
				return zone = n;
			}
		});

		return zone;
	}

	Toposequence.prototype.goToHome = function () {
		this.reset(2)
	}

	Toposequence.prototype.goToScrenSaver = function () {

		// Super constructor
		var shouldReset =  BaseGame.prototype.shouldReset.call(this);

		if(shouldReset) {
			this.reset(1);
		}
	}

	Toposequence.prototype.reset = function (destinationScreen) {

		// Define destination screen
		destinationScreen = destinationScreen || 1;

		// Go to screen
		this.goToScreen(destinationScreen);
	}


	// Expose Toposequence
	window.Toposequence = Toposequence;

})(jQuery, Promise);